import { jsx as m, jsxs as f } from "react/jsx-runtime";
import { c as a } from "react/compiler-runtime";
import g from "@mui/material/DialogTitle";
import h from "@mui/material/DialogContent";
import u from "@mui/material/DialogActions";
import d from "@mui/material/IconButton";
import x from "@mui/icons-material/Close";
import C from "@mui/material/Typography";
import D from "@mui/material/Dialog";
const j = (i) => {
  const e = a(10);
  let l, t, o;
  e[0] !== i ? ({
    children: l,
    onClose: t,
    ...o
  } = i, e[0] = i, e[1] = l, e[2] = t, e[3] = o) : (l = e[1], t = e[2], o = e[3]);
  let r;
  e[4] !== t ? (r = (s, c) => c === "backdropClick" ? void 0 : t?.(), e[4] = t, e[5] = r) : r = e[5];
  let n;
  return e[6] !== l || e[7] !== o || e[8] !== r ? (n = /* @__PURE__ */ m(D, { onClose: r, ...o, children: l }), e[6] = l, e[7] = o, e[8] = r, e[9] = n) : n = e[9], n;
}, v = (i) => {
  const e = a(13);
  let l, t, o;
  e[0] !== i ? ({
    children: l,
    onClose: t,
    ...o
  } = i, e[0] = i, e[1] = l, e[2] = t, e[3] = o) : (l = e[1], t = e[2], o = e[3]);
  let r;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = {
    display: "flex",
    alignItems: "center"
  }, e[4] = r) : r = e[4];
  let n;
  e[5] !== l ? (n = /* @__PURE__ */ m(C, { variant: "h6", sx: r, children: l }), e[5] = l, e[6] = n) : n = e[6];
  let s;
  e[7] !== t ? (s = t ? /* @__PURE__ */ m(d, { "aria-label": "close", style: {
    position: "absolute",
    right: "8px",
    top: "8px"
  }, onClick: t, size: "large", children: /* @__PURE__ */ m(x, {}) }) : null, e[7] = t, e[8] = s) : s = e[8];
  let c;
  return e[9] !== o || e[10] !== n || e[11] !== s ? (c = /* @__PURE__ */ f(g, { ...o, children: [
    n,
    s
  ] }), e[9] = o, e[10] = n, e[11] = s, e[12] = c) : c = e[12], c;
}, A = (i) => {
  const e = a(6);
  let l, t;
  e[0] !== i ? ({
    children: l,
    ...t
  } = i, e[0] = i, e[1] = l, e[2] = t) : (l = e[1], t = e[2]);
  let o;
  return e[3] !== l || e[4] !== t ? (o = /* @__PURE__ */ m(h, { ...t, children: l }), e[3] = l, e[4] = t, e[5] = o) : o = e[5], o;
}, B = u;
export {
  B as DialogActions,
  j as DialogBox,
  A as DialogContent,
  v as DialogTitle
};
